import IconButton from "@mui/material/IconButton";
import EditIcon from "@mui/icons-material/Edit";
import CheckIcon from "@mui/icons-material/Check";
import { useBrandSetupReadOnly } from "../context/brandSetupReadOnlyContext";

export const EditActionButtons = ({
  isEditing,
  onEdit,
  onSave,
  buttonSize = 32,
  saveButtonSx = {},
}) => {
  const readOnly = useBrandSetupReadOnly();

  if (readOnly) {
    return null;
  }

  if (!isEditing) {
    return (
      <IconButton
        size="small"
        onClick={onEdit}
        sx={{
          width: buttonSize,
          height: buttonSize,
          color: "text.secondary",
        }}
      >
        <EditIcon sx={{ fontSize: 20 }} />
      </IconButton>
    );
  }

  return (
    <IconButton
      size="small"
      onClick={onSave}
      sx={{
        width: buttonSize,
        height: buttonSize,
        ...saveButtonSx,
      }}
    >
      <CheckIcon sx={{ fontSize: 20 }} />
    </IconButton>
  );
};

export default EditActionButtons;
